import { Action, IResourceItem, useTranslation } from "@refinedev/core";
import { DocumentTitleHandler } from "@refinedev/react-router";

type Options = {
    resource?: IResourceItem;
    action?: Action;
    params?: Record<string, string | undefined>;
    pathname?: string;
    autoGeneratedTitle: string;
}

export const CustomDocumentTitleHandler = () => {
    const { translate } = useTranslation();
    const customTitleHandler = ({ resource, action, params = {}, pathname }: Options) => {
        // logger.debug(resource, action, params, pathname)

        let title = "Hachimind"; // Default title

        if (resource?.meta?.label) {
            title = `${translate(resource.meta?.label)} | ${title}`;
        } if (resource?.name) {
            title = `${resource.name} | ${title}`;
        } else {
            title = `${title}` //autoGeneratedTitle
        }

        return title;
    }

    return <DocumentTitleHandler handler={customTitleHandler} />;
};
